@import "src/helpers/ScreenSizes.scss"; //mixins for different screen sizes

#otpInput {
  margin: 0 auto;
}

.otpParentDiv {
  width: 376px;
  min-width: 210px;
  display: flex;
  align-items: center;
  align-self: center;
  flex-direction: column;
}

.otpInputDiv {
  max-width: 376px;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  align-self: center;
  margin-top: 40px;
  position: relative;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 12px;

  @include small() {
    max-width: 330px;
    margin-top: 15px;
  }
}

.otpInput {
  display: inline-block;
  margin: 0 0.3rem;
  width: 1.8rem;
  height: 2.4rem;
  border: 0;
  border-radius: 0;
  border-bottom: 2px solid transparent;
  text-align: center;

  font-size: 32px;
  font-family: "Roboto Mono", monospace;
  color: #16182b;

  font-weight: 700;
  font-style: normal;
  line-height: 38px;
  font-feature-settings: "liga" off;
  outline: none;
  caret-color: transparent;
  padding: 0;

  @include extraSmall() {
    font-size: 24px;
    width: 1.2rem;
    height: 2rem;
  }
}

.otpInput::selection {
  color: rgba(0, 0, 0, 1);
}

.otpInput:invalid {
  border-bottom: 2px solid #000;
}

.otpInput:focus {
  outline: none;
}

/* Chrome, Safari, Edge, Opera */
.otpInput::-webkit-outer-spin-button,
.otpInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.otpInput[type="text"] {
  -moz-appearance: textfield;
}

.errorOutline {
  outline: 2px solid #ef2039;
}

.otpMinorError {
  position: relative;
  margin-top: 8px;
  max-width: 100%;
  padding-left: 42px;
  padding-right: 42px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: center;

  letter-spacing: 0.2px;

  color: #ef2039;

  @include small() {
    padding-left: 52px;
    padding-right: 52px;
  }
}
